module.exports = __webpack_public_path__ + "img/location_see.b05bc3cc.png";